import { createRouter, createWebHistory } from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import { getRoutes } from './config';
import { permsBeforeEach } from '@tencent/iegsp-common/tools/utils/route';

export const allRoutes = [...getRoutes()];

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL || '/'),
  routes: allRoutes,
  scrollBehavior() {
    return {
      el: '#app',
      top: 0,
      behavior: 'smooth',
    };
  },
});
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  permsBeforeEach({
    to: to as any,
    from: from as any,
    router,
  })
    .then((res: any) => {
      if (res === true) return next();
      if (res?.path) return next(res);
      return next();
    })
    .catch(() => {
      next(false);
    });
});

router.afterEach((to) => {
  if (to.meta?.title) {
    document.title = `${to.meta.title}`;
  }
  NProgress.done();
});

export default router;
